import gql from 'graphql-tag';

export const GET_FORM_DATA = gql`
  query GetForm($Id: String) {
    GetForm(Id: $Id) {
      Data
      FormId
    }
  }
`;
